module.exports = __webpack_public_path__ + "static/media/logoJEST.2ab29be4.svg";